(function () {
  'use strict';

  var configNode = document.getElementById('ce-english-usd-visual-config');
  if (!configNode) return;

  var config;
  try {
    config = JSON.parse(configNode.textContent || '{}');
  } catch (error) {
    console.warn('[CE USD visual] Invalid configuration.', error);
    return;
  }

  var rate = Number(config.rate);
  var variants = config.variants || {};
  var currentVariantId = String(config.selectedVariantId || '');
  var eventVariantId = '';
  var observer = null;
  var renderTimer = null;

  if (!Number.isFinite(rate) || rate <= 0 || rate >= 1 || !Object.keys(variants).length) return;

  function variantById(variantId) {
    return variants[String(variantId || '')] || null;
  }

  function selectedVariantId() {
    if (eventVariantId && variantById(eventVariantId)) {
      return eventVariantId;
    }

    var inputs = document.querySelectorAll([
      '.ce-product-form [name="id"]',
      '.t4s-main-product__content form[action*="/cart/add"] [name="id"]',
      '.t4s-main-product__content [name="id"]'
    ].join(','));
    for (var index = 0; index < inputs.length; index += 1) {
      if (variantById(inputs[index].value)) return String(inputs[index].value);
    }

    if (variantById(currentVariantId)) return currentVariantId;

    var urlVariant = new URLSearchParams(window.location.search).get('variant');
    return variantById(urlVariant) ? String(urlVariant) : Object.keys(variants)[0];
  }

  function classifyPrice(variant) {
    var priceMinor = Math.round(Number(variant && variant.priceMinor) || 0);
    var compareAtMinor = Math.round(Number(variant && variant.compareAtMinor) || 0);
    var hasSale = compareAtMinor > priceMinor && priceMinor > 0;
    var isAutomaticFivePercent = hasSale &&
      !config.hasSemDesconto &&
      priceMinor === Math.floor(compareAtMinor * 95 / 100);

    return {
      priceMinor: priceMinor,
      compareAtMinor: compareAtMinor,
      hasSale: hasSale,
      isAutomaticFivePercent: isAutomaticFivePercent,
      displayMinor: isAutomaticFivePercent ? compareAtMinor : priceMinor
    };
  }

  function convertMinor(brlMinor) {
    return Math.round((Number(brlMinor) || 0) * rate);
  }

  function formatUsd(brlMinor) {
    var usdMinor = convertMinor(brlMinor);
    var formatted;
    try {
      formatted = new Intl.NumberFormat(config.locale || 'en-US', {
        style: 'currency',
        currency: config.currency || 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(usdMinor / 100);
    } catch (error) {
      formatted = '$' + (usdMinor / 100).toFixed(2);
    }
    return formatted + ' USD';
  }

  function priceNodes() {
    var selectors = [
      '.ce-product-detail__price [data-pr-price][data-product-price]',
      '.ce-product-sticky [data-pr-price][data-product-price]',
      '.t4s-main-product__content .t4s-product__price-review [data-pr-price][data-product-price]',
      '[data-sticky-addtocart] [data-sticky-price]'
    ];
    var nodes = [];
    selectors.forEach(function (selector) {
      Array.prototype.forEach.call(document.querySelectorAll(selector), function (node) {
        if (nodes.indexOf(node) === -1) nodes.push(node);
      });
    });
    return nodes;
  }

  function priceHtml(priceState) {
    if (priceState.hasSale && !priceState.isAutomaticFivePercent) {
      return '<del><span class="notranslate ce-money ce-usd-price-value" data-ce-usd-price>' +
        formatUsd(priceState.compareAtMinor) +
        '</span></del> <ins><span class="notranslate ce-money ce-usd-price-value" data-ce-usd-price>' +
        formatUsd(priceState.priceMinor) +
        '</span></ins>';
    }
    return '<span class="notranslate ce-money ce-usd-price-value" data-ce-usd-price>' +
      formatUsd(priceState.displayMinor) +
      '</span>';
  }

  function renderPriceNode(node, variantId, priceState) {
    if (!node || priceState.displayMinor <= 0) return;
    var mode = priceState.isAutomaticFivePercent ? 'full' : (priceState.hasSale ? 'sale' : 'regular');
    var fingerprint = [variantId, mode, priceState.priceMinor, priceState.compareAtMinor, rate].join('|');
    if (node.getAttribute('data-ce-usd-fingerprint') === fingerprint && node.querySelector('[data-ce-usd-price]')) return;

    node.innerHTML = priceHtml(priceState);
    node.setAttribute('data-ce-usd-fingerprint', fingerprint);
    node.setAttribute('data-ce-usd-visual', mode);
    node.setAttribute('aria-label', 'Estimated price ' + formatUsd(priceState.displayMinor));
  }

  function ensureNotice() {
    if (document.getElementById('ce-usd-estimate-note')) return;
    var anchor = document.querySelector('.ce-product-detail__price') ||
      document.querySelector('.t4s-main-product__content [data-pr-price][data-product-price]');
    if (!anchor) return;

    var note = document.createElement('p');
    note.id = 'ce-usd-estimate-note';
    note.className = 'ce-usd-estimate-note';
    note.setAttribute('role', 'note');
    var rateDate = config.rateDate ? ' on ' + String(config.rateDate) : '';
    var rateSource = config.rateSource ? String(config.rateSource) : 'reference rate';
    note.textContent = 'Estimated USD price based on the BRL list price at 1 BRL = ' +
      rate.toFixed(6) + ' USD (' + rateSource + rateDate + '). Checkout displays and charges the current BRL price; this estimate does not change discounts or the amount charged. Your card issuer determines the final conversion.';
    anchor.insertAdjacentElement('afterend', note);
  }

  function render() {
    var variantId = selectedVariantId();
    var variant = variantById(variantId);
    if (!variant) return;
    currentVariantId = String(variantId);

    var priceState = classifyPrice(variant);
    document.documentElement.classList.add('ce-english-usd-visual');
    document.documentElement.classList.toggle('ce-english-usd-auto-price', priceState.isAutomaticFivePercent);
    priceNodes().forEach(function (node) {
      renderPriceNode(node, currentVariantId, priceState);
    });
    ensureNotice();
  }

  function scheduleRender(delay) {
    window.clearTimeout(renderTimer);
    renderTimer = window.setTimeout(render, delay || 0);
  }

  function bindVariantEvents() {
    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.closest || !target.closest('.t4s-main-product__content, .ce-product-detail')) return;
      if (target.name === 'id' && variantById(target.value)) {
        currentVariantId = String(target.value);
        eventVariantId = '';
      }
      scheduleRender(20);
    });

    if (window.jQuery_T4NT) {
      window.jQuery_T4NT(document).on('variant:changed.ceUsdVisual', function (event, variant) {
        var nextVariant = variant || event.currentVariant || event.detail;
        if (nextVariant && variantById(nextVariant.id)) {
          currentVariantId = String(nextVariant.id);
          eventVariantId = currentVariantId;
        }
        scheduleRender(0);
      });
    }
  }

  function startObserver() {
    if (!window.MutationObserver || observer) return;
    var roots = [];
    ['#MainContent', '.ce-product-detail', '.t4s-main-product__content', '[data-sticky-addtocart]'].forEach(function (selector) {
      var root = document.querySelector(selector);
      if (root && roots.indexOf(root) === -1) roots.push(root);
    });
    if (!roots.length) return;
    observer = new MutationObserver(function () {
      scheduleRender(0);
    });
    roots.forEach(function (root) {
      observer.observe(root, { childList: true, subtree: true, characterData: true });
    });
  }

  function init() {
    render();
    bindVariantEvents();
    startObserver();
    [250, 800, 1800].forEach(function (delay) {
      window.setTimeout(render, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
